export const lang = {
  hero:
    '世界最大の科学および工学コンテストを通じて、世界中の才能ある若者がどのようにグローバルで相互接続された STEM コミュニティに紹介されるのか。',
  intro: [
    '科学、技術、工学、数学 (STEM) の分野は、かつてないほどグローバルに相互接続されています。',
    '科学協会が設立、運営する世界最大の STEM コンテストである リジェネロン国際学生科学技術フェア (Regeneron ISEF) に参加してみませんか。Regeneron ISEF は毎年、世界中から優秀な若者を結集させ、社会の最も緊急な課題に取り組む革新的で潜在的に変革をもたらす可能性のある研究を紹介します。',
    '気候変動や新たなパンデミックから食糧不足やメンタルヘルスに至るまで、STEM における将来の進歩は、世界中の何百万もの人々の生活に影響を与えるでしょう。だからこそ、多様な考え方や背景を持つ新世代の科学者を育成することが、理想的であるだけでなく、不可欠であるのです。',
    '73 年の歴史を通じて、このコンテストの世界的な舞台は、ノーベル賞受賞者からテクノロジー起業家、先駆的な研究者など、多くの才能ある若いイノベーターを STEM 分野で優れたキャリアを達成するよう導いてきました。 現在、Regeneron ISEF はその伝統を引き継ぎ、世界的な STEM 人材のインキュベーターとしての役割を果たし、明日の課題に正面から立ち向かう次世代の情熱と好奇心を刺激します。',
    'Regeneron ISEF と、世界規模で若い STEM 人材に力を与えることの重要性について詳しく知るために、私たちは今日、STEM 分野で実績と受賞歴を誇る専門家に相談しました。これらの業界リーダーは元 ISEF ファイナリストでもあり、指導や審査員として Regeneron ISEF で今も活躍している人もいます。',
    'これら 3 人の STEM 著名人は、Regeneron ISEF での経験、キャリアの軌跡に与えた影響、STEM の将来についての展望を共有します。'
  ],
  panelists: [
    {
      name: 'アシャ・ピライ博士',
      copy:
        'ピライ博士は、リジェネロンの世界開発科学評議会の議長であり、マイアミ大学、セント・ジュード小児研究病院、スタンフォード大学医学部で教鞭をとった教授です。'
    },
    {
      name: 'ファティマ・コーディ・スタンフォード博士',
      copy:
        'スタンフォード博士は肥満医学の医師であり、ハーバード大学医学部の准教授であり、マサチューセッツ総合病院のエクイティ・ディレクターでもあります。'
    },
    {
      name: 'ウィリー T. リーブス ジュニア',
      copy:
        'ウィリー T. リーブス ジュニア は、細胞治療技術プラットフォーム企業である Cellino (セリノ) のパブリック エンゲージメント責任者であり、National Leadership Council (国家リーダーシップ評議会) の理事であり、Research & Engineering Apprenticeship Program (REAP, 研究とエンジニアリング　アプレンティスシップ　プログラム) フェローでもあります'
    }
  ],

  chapter: [
    {
      eyebrow: 'アシャ・ピライ博士',
      head: '地球規模の課題に対するグローバルなアプローチ',
      copy: [
        '1985 年から 1986 年の ISEF に高校生として参加したとき、アシャ・ピライ博士はイベントの多様化についてISEF指導部に手紙を書きました。当時彼女は15歳でした。',
        '「私は世界中から真の代表者を集めることを求めて手紙を書きました」と博士は言う。リジェネロンの医師科学者であるピライ博士は、「私がそこにいたとき、ISEF は実際には多くの国の代表ではなかったからです。多様なアイデンティティを持った人たちがいましたが、彼らは西側諸国から来ていました。」',
        '今年、彼女は審査員および講演者として Regeneron ISEF に参加し、彼女の言葉を借りれば「文字通りアルメニアからジンバブエまで」60 か国以上が参加していることを誇りに思いました。」 過去の経験について尋ねると、ピライ博士は、「Regeneron で働くようになって、恩返しするこの機会を与えられたことで、物事が一周したと感じました。」と語ります。',
        'ピライ博士にとって、リジェネロン ISEF はこれまでも、そしてこれからも、科学技術の未来を奨励し、より良いものにする機会です。そして、新しいテクノロジーの成長により、私たちがますます相互に結びついた世界に住むようになるにつれ、これはこれまで以上に重要に感じられる機会となっています。',
        'ピライ博士によれば、「世界はますます小さくなっている。そして、このグローバル化が進むにつれて、多様な理解や多様なテクノロジーを持たない人々は不利な立場に置かれます。」',
        'ピライ博士は、より多様な科学協力に対するダーウィン的な視点もあると述べています。「純粋に科学的に見たいのであれば、現時点では種が多様化しないように選択していることになります。」 世界的な問題がエスカレートするにつれて、STEM にさまざまな視点を持ち込むことの重要性はますます高まっています。',
        'こうした世界的な問題にもかかわらず、「私はとても希望を持っています」とピライ博士は言います。今年の Regeneron ISEF では、ピライ博士は、現状に挑戦し、印象的な科学研究を共有し、協力することに意欲的な参加者を経験しました。「私は指導者として、そして審査員として働くことになり、本当に地球のための解決策を生み出すという希望を持った若者たちのグループを見てきました」と彼女は言います。「彼らは素朴に見えることを恐れていません。」 ピライ博士は、将来の科学者は粘り強く、「自分たちが見ている問題について、より探究的で深い質問をする」必要があると語っています。'
      ]
    },
    {
      eyebrow: 'ファティマ・コーディ・スタンフォード博士',
      head: '表現が重要',
      copy: [
        '表現は重要であり、STEM においてより多様な考え方を奨励することができます。博士に聞いてください。マサチューセッツ総合病院の肥満医学医師科学者であるファティマ・コディ・スタンフォード博士は、キャリアを通じて表現について考えてきました。スタンフォード博士は、より多くの代表者を獲得するには、特に過小評価されたコミュニティにおいて、幼い頃から科学を導入することから始まると信じていると語ります。',
        '「13歳か14歳で科学チームを率いることができると信じれば、大学、医学部、大学院に進学する準備が整い、『私にはこれができる』と思えるのです」とスタンフォード博士は言います。',
        'Regeneron ISEF の現実世界の価値について考えるとき、スタンフォード博士は、医療従事者として日々直面する課題について考えています。医学の観点から言えば、例えば臨床試験や研究が人口の一部のみを代表する場合、科学の進歩が妨げられるため、代表は重要です。2023年の国立衛生研究所（NIH） ',
        '、 「基礎研究と臨床研究で生物学的多様性の全範囲を確実に表現するには、多様な集団からの患者サンプルを含めることが重要である」と報告されています。',
        '「現場に足を踏み入れて、自分が研究参加者として、または研究者として重要であるとすぐに感じなければ、その空間に留まることはできません」とスタンフォード博士は言っています。ソリューションを作成する個人が、解決しようとしている問題によって影響を受ける人々の多様性を反映していることが重要です。これが、彼女があらゆる背景を持つ学生に STEM 分野、特に医学の分野に目を向けるよう勧めている理由です。「現在、医療のあらゆる分野で過小評価が行われています」と彼女はBIPOCについて言います。「たとえば、黒人医師の数に注目すると、過去 200 年間で 3% しか変わっていません。」',
        '2024 年、Regeneron ISEF には学生がエントリーできる 22 の異なるカテゴリーが用意される予定です。スタンフォード博士は、入学者に対し、10代から青年期にかけてさまざまな分野に挑戦するようアドバイスしています。これは彼女が自分自身のために選んだ道と同じです。リジェネロン ISEF は、「人生の早い段階で科学の進歩の最前線に触れる機会」を提供します、とスタンフォード博士は言います。'
      ],
      footnote: {
        title:
          '“A Lack of Diversity, Equity, and Inclusion in Clinical Research Has Direct Impact on Patient Care,”',
        src: 'National Institutes of Health, 2023'
      },
      hyperlink: {
        a: 'の報告書では',
        href: 'https://www.ncbi.nlm.nih.gov/pmc/articles/PMC9946429/'
      }
    },
    {
      eyebrow: 'ウィリー T. リーブス ジュニア',
      head: '達成を祝うことはより大きなエンゲージメントにつながる',
      copy: [
        'ウィリー T. リーブス ジュニアは、細胞治療技術プラットフォーム企業である Cellino (セリノ) のパブリック エンゲージメント責任者であり、高校の3年生および4年生の時にISEF に参加しました。',
        '彼は、世界中の参加者間の社会的つながりを促進する祝賀と激励の環境、そしてそれが最終的に STEM 分野全体のより明るい未来に貢献することを再認識しました。一言で言えば、「文化と科学の卓越性を美しく披露する、まさに大きなパーティーのようなものです」とリーブス氏は ISEF の経験について語ります。',
        '多様な ISEF 参加者と会うことで、「自分は彼らから何を学ぶことができ、また彼らは自分から何を学ぶことができるか?」といった、視野を広げる質問をするようになったと彼は言います。',
        'リーブス氏は、国境を越えてつながりを作り、新しく挑戦的な考え方を発見することの価値に加えて、STEM のキャリア パスの幅広さを示し、「科学」と「科学者」がどのようなものであるかという概念に挑戦することの重要性も強調しています。リーブス氏は次のように説明します。「多くの人は、科学は実験室やシャーレの中、あるいは顕微鏡の下でのみ行われるというビジョンを頭の中に持っていると思います。そして確かに、こうした光景は、あらゆる場所にありますが、それ以上のものでもあります。」',
        '同じことが私たちが科学者に対して抱く見方にも当てはまると彼は指摘します。「もし私があなたの頭の中に科学者を想像して欲しいと言ったら、その人はどんな様子をしていますか？白衣を着た年配の白人男性を想像したとしたら、それは社会が永続させてきたフィードバックループとメッセージのせいです。」',
        'リーブス氏は、学生たちにこれらの概念に挑戦するよう奨励し、Regeneron ISEF の素晴らしい点の 1 つは、若い科学者の世界的なコミュニティを結集し、STEM トピックの多様性に焦点を当て、学生たちが新たなキャリアの可能性を想像できるようにすることであると指摘しています。これは彼が非常に情熱を注いでいるテーマです。',
        '「[Regeneron ISEF] は将来、非常に多くのさまざまなことの素晴らしい出発点として機能する可能性があります」とリーブス氏は言います。彼は自分のキャリアがこの事実の証拠であると考えています。'
      ]
    },
    {
      eyebrow: 'リジェネロンのエキスパート',
      head: '将来の STEM キャリアへのつながり',
      copy: [
        'STEM の未来は今起こりつつあり、Regeneron ISEF は、若い科学者がつながりを作り、知識を得、世界の科学コミュニティからサポートとアドバイスを受けるためのプラットフォームであり続けます。',
        'リーブス氏のようなリーダーとともに、スタンフォード博士とピライ博士が科学志向の若い学生を指導していることから、STEM の将来に希望が持てるでしょう。',
        '「私たちは専門家として成長してきましたが、お互いや他の人にどのように利益をもたらすことができるかという点で、その機会の効果を引き続き実感しています」と博士はISEF 卒業生が科学コミュニティに貢献していることについて語ります。リジェネロンのアンバサダーおよびメンターとして、将来の科学者をサポートすることは博士にとって重要です。',
        'スタンフォード博士は、参加者としての博士自身の形成的な経験により、時間のかなりの部分を指導に集中するようになりました。「ISEF で私をサポートしてくれた AP 生物学の講師とは今でも連絡を取り合っています」とスタンフォード博士は言います。「彼女はもう90歳近くになりますが、彼女はいつも私の中に、私が存在さえ知らなかった何かを見出すことができました。それが、私が今日、特に科学分野で過小評価されている人々の指導者になった理由の一部であり、それが私の人生の使命の一部となっています。」',
        'リーブス氏は5月にリジェネロンISEFに戻り、今回は科学協会のさまざまな競技会の同窓会リーダーで構成される協会全国リーダーシップ評議会のメンバーとして参加しました。「開会式を見て、学生の数と代表国の数の多さにただただ驚きました」と彼は言います。「まさに文化の美しい展示でした。」 文化の展示は間違いなく成長を続け、将来の STEM の進歩に必要な多様な科学的才能を奨励します。'
      ]
    }
  ],

  infographic: [
    {
      head: 'STEM を世界的に奨励する',
      subhead: '以下はその世界的な影響のスナップショットです。',
      copy:
        '毎年、Regeneron ISEF は才能ある学生を最大規模の世界的な科学工学フェアに参加するよう招待しています。この取り組みには、世界中の地元の学校や学区の参加が必要です。 ',
      plus: 'ヶ国以上',

      plusclass: 'infographics__map__stat__num__plus infographics__map__stat__num__plus--ja',
      color: 'blue',
      stat: [
        'ISEFで代表される国',
        '高校生が毎年、世界中の地元のサイエンスフェアで競い合っています。',
        'ISEF 提携のサイエンス フェアのコンテストが世界中で開催されています。'
      ]
    },
    {
      head: '数字で見る ISEF',
      subhead: 'その影響を測定する方法は次のとおりです。',
      copy: 'Regeneron ISEF の影響と利点は数多くあります。',
      color: 'pink',
      number: ['万+', '1,600+', '50%', '万ドル'],
      stat: [
        'Regeneron は、Regeneron ISEF およびその他のプログラムを通じて、魅力的な STEM 体験を学生に提供してきました (2020 年以降)。',
        '毎年 Regeneron ISEF にやって来て競い合う学生ファイナリスト。',
        '女性であるRegeneron ISEF参加者。',
        '研究とイノベーションに資金を提供するために、Regeneron ISEF のファイナリストに毎年与えられる賞のおおよその額。'
      ]
    }
  ],
  inline: [
    {
      srcD: 'https://cdn.courageousstudios.com/assets/sponsorcontent/regeneron/hero-l.jpg',
      srcM: 'https://cdn.courageousstudios.com/assets/sponsorcontent/regeneron/hero-s.jpg'
    },
    {
      srcD: 'https://cdn.courageousstudios.com/assets/sponsorcontent/regeneron/inline1-l.jpg',
      srcM: 'https://cdn.courageousstudios.com/assets/sponsorcontent/regeneron/inline1-s.jpg',
      caption:
        'アシャ・ピライ博士は、Regeneron ISEF の学生や出席者に自分の経験を披露します。彼女は、2023年に裁判官およびメンターを務めることで恩返しをしました。'
    },
    {
      srcD: 'https://cdn.courageousstudios.com/assets/sponsorcontent/regeneron/inline2-l.jpg',
      srcM: 'https://cdn.courageousstudios.com/assets/sponsorcontent/regeneron/inline2-s.jpg',
      caption:
        'ISEF の元参加者として、ファティマ・コーディ・スタンフォード博士は、自分の経験が STEM（科学・技術・工学・数学）分野でのキャリア追求を可能にするという自信を深めることになったと考えています。同様に、Regeneron ISEF は世界中の意欲的な若い科学者を奨励し続けています。'
    },

    {
      srcD: 'https://cdn.courageousstudios.com/assets/sponsorcontent/regeneron/inline4-l.jpg',
      srcM: 'https://cdn.courageousstudios.com/assets/sponsorcontent/regeneron/inline4-s.jpg',
      caption:
        'ウィリー T. リーブス ジュニア は 2007 年と 2008 年に ISEF に参加しました。それ以来、彼は国家指導評議会（National Leadership Council）の理事を務めています。'
    },
    {
      srcD: 'https://cdn.courageousstudios.com/assets/sponsorcontent/regeneron/inline5-l.jpg',
      srcM: 'https://cdn.courageousstudios.com/assets/sponsorcontent/regeneron/inline5-s.jpg',
      caption:
        'Regeneron ISEF は、学生が大学の授業料を支払ったり、将来の研究への資金に活用できるような賞品、報償、奨学金を通じて、世界中の学生をサポートし続けています。'
    }
  ],
  vimeo: {
    id: '892693553',
    idmobile: '892722370'
  },
  cta: {
    href:
      'https://www.regeneron.com/global/our-culture?utm_medium=paid-partnership&utm_source=cnn&utm_campaign=isef_japan&utm_content=article_1_cta',
    copy: '詳細については、',
    url: 'regeneron.com/global/our-culture',
    copy2: ' をご覧ください'
  }
};
